import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { Button } from "@/components/Button";
import { LinkButton } from "@/components/LinkButton";

import { ICTASection } from "./types";

type IProps = ICTASection & JSX.IntrinsicElements["div"];

export const CTASection: React.FC<IProps> = ({
  title,
  subtitle,
  wrapperBgColor = "#fff",
  buttonLabel,
  href,
  onButtonClick,
  buttonStyle = {},
  isBetaFormat = false,
  ...rest
}) => {
  const { css } = useFela();
  const { t } = useTranslation();

  const buttonStyles = {
    width: "auto",
    padding: "0 26px",
    margin: "auto",
    boxShadow: "0 18px 54px 0 rgba(255, 111, 2, 0.5)",
    ...buttonStyle,
  };

  const ctaButtonLabel =
    buttonLabel ||
    (isBetaFormat
      ? t("section/cta:buttonBetaLabel")
      : t("section/cta:buttonDefaultLabel"))!;

  return (
    <Grid
      id="CTASection"
      customStyle={{
        flexDirection: "column",
      }}
      wrapperStyle={{
        backgroundColor: wrapperBgColor,
      }}
      {...rest}
    >
      <div
        className={css({
          textAlign: "center",
        })}
      >
        <Heading as="h2">{title}</Heading>
      </div>
      {subtitle && (
        <p
          className={css({
            textAlign: "center",
            marginBottom: 30,
            fontSize: 18,
            lineHeight: "28px",
          })}
        >
          {subtitle}
        </p>
      )}

      {href && (
        <LinkButton
          title={ctaButtonLabel}
          href={href[0] !== "#" ? href : undefined}
          scrollToId={href[0] === "#" ? href.slice(1) : undefined}
          customStyle={buttonStyles}
          target="_blank"
        />
      )}

      {!href && onButtonClick && (
        <Button onClick={onButtonClick} customStyle={buttonStyles}>
          {ctaButtonLabel}
        </Button>
      )}
    </Grid>
  );
};
